<template>
  <div class="d-flex align-items-center">
    <user-short
      class="actor-detail"
      :truncate-name="true"
      :user-id="activity.actorId || activity.actor.id"
      :length="avatarSize"
      :show-user-name="false"
    ></user-short>
    <span class="d-flex px-2 text-nowrap">
      <router-link
        :to="userPageLocation"
        class="text-primary bold first-name text-truncate"
        :title="firstName"
        v-no-capture
        >{{ firstName }}</router-link
      >
      &nbsp;
      <router-link :to="getEntityHref(true)" class="text-primary text-medium-1 pointer">
        {{ actionLabel }}
      </router-link>
    </span>
  </div>
</template>

<script>
import UserShort from '@/components/UserShort'
import { ROUTE_NAMES } from '@/constants/routes'
import ActivityMixin from '@/mixins/ActivityMixin'

/**
 * This shows activity label(e.g Alice added a comment) along with actor's avatar
 */
export default {
  name: 'ActivityLabel',
  props: {
    activity: Object,
    actionLabel: String,
    teamId: Number,
    avatarSize: {
      default: 30
    }
  },
  mixins: [ActivityMixin],
  components: {
    UserShort
  },
  computed: {
    firstName() {
      let firstName = this.activity.actor?.firstName
      if (!firstName) {
        firstName = this.firstNameById(this.activity.actorId)
      }
      return firstName
    },
    userPageLocation() {
      return {
        name: ROUTE_NAMES.USER,
        params: {
          orgId: this.activity.organizationId,
          userId: this.activity.actorId
        }
      }
    }
  },
  methods: {
    firstNameById(id) {
      const user = this.$store.getters.userById(id)
      return user && user.firstName
    }
  }
}
</script>

<style lang="scss" scoped>
.first-name {
  max-width: 100px;
}
</style>
